export const waitPlz = milliseconds => new Promise(r => setTimeout(() => r, milliseconds))
